/**
 * Shared Clerk `appearance` definition for the www→dashboard conversion
 * funnel (issue #876). Every Clerk sign-up/sign-in modal opened from the
 * locked-report CTA (LockedReportView, wired via App.tsx) and from
 * ClaimLanding must use this single object — no per-callsite duplication,
 * one branded voice.
 *
 * The modal keeps Clerk's stock white surface (decision 2026-09-25). #876
 * originally themed it dark to match the report hero, but the dark overrides
 * never covered Clerk's full element tree: the footer rendered in a second,
 * derived shade, the GitHub mark vanished, and placeholders went faint. The
 * stock light card is internally consistent by construction. Branding rides
 * on the primary color and fonts only, and a dark blurred scrim sets the page
 * behind it aside. Every color below comes from `T.*` in designTokens.ts.
 */
import { T } from './designTokens';

export interface ClerkAppearance {
  variables: Record<string, string>;
  elements: Record<string, Record<string, unknown>>;
}

export const clerkAppearance: ClerkAppearance = {
  variables: {
    colorPrimary: T.cobalt600,
    borderRadius: `${T.radiusMd}px`,
    fontFamily: T.fontBody,
  },
  elements: {
    // Clerk's stock backdrop is a light tint that let the teaser's headline
    // bleed through around the card; the shared scrim token plus a blur
    // mutes it.
    modalBackdrop: {
      backgroundColor: T.scrim,
      backdropFilter: 'blur(4px)',
    },
    headerTitle: {
      // The serif is for headlines at 20px and up only (#1936), so the
      // modal title is set at the floor rather than Clerk's smaller default.
      fontFamily: T.fontDisplay,
      fontSize: '20px',
      fontWeight: 600,
    },
    formButtonPrimary: {
      backgroundColor: T.cobalt600,
      color: T.white,
    },
  },
};
